<!-- app.vue -->
<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!-- 택배사 재인증 모달 (전체 화면, 전역) -->
    <CourierReauthModal
      :is-open="reauthModalState.isOpen"
      :courier-id="reauthModalState.courierId"
      :company-id="reauthModalState.companyId"
      @close="handleReauthClose"
      @success="handleReauthSuccess"
    />

    <!-- 전역 다이얼로그 (alert/confirm 대체) -->
    <DialogContainer />
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import { useCourierErrorHandler } from '@/composables/courier/useCourierErrorHandler'
  import { useUnifiedNotification } from '@/composables/notification/useUnifiedNotification'
  import CourierReauthModal from '@/components/courier/CourierReauthModal.vue'
  import DialogContainer from '@/components/common/DialogContainer.vue'

  // 택배사 재인증 모달
  const { reauthModalState, closeReauthModal } = useCourierErrorHandler()

  // 알림 시스템
  const { hideAll } = useUnifiedNotification()

  // 라우터 네비게이션 감지
  const router = useRouter()
  router.beforeEach((to, from) => {
    // 다른 페이지로 이동할 때만 알림 제거 (같은 페이지 내 쿼리 변경 등은 제외)
    if (to.path !== from.path) {
      hideAll()
    }
  })

  function handleReauthClose() {
    closeReauthModal()
    // 닫기 콜백 실행 (있으면)
    if (reauthModalState.value.onClose) {
      reauthModalState.value.onClose()
    }
  }

  function handleReauthSuccess() {
    closeReauthModal()
    // 재인증 성공 시 콜백 실행 (있으면)
    if (reauthModalState.value.onSuccess) {
      reauthModalState.value.onSuccess()
    }
  }
</script>
